// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25TEt","footer":"styles_footer__cFDpz"};